import { isEmpty, reject } from "lodash";
import CoreDefault from "@/core/Defaults";
// types
import TApplicationDocument from "@/cms/types/TApplicationDocument";
// hooks
import useProgressiveImage from "@/hooks/useProgressiveImage";
// utilities
import ApplicationDocumentSelector, { TApplicationDocumentSelector } from "@/utilities/ApplicationDocumentSelector";


type TPageBanner = {

    title?: string|null;
    description?: string|null;
    imagePath?: string|null;

} & TApplicationDocumentSelector;


const PageBanner = (props: TPageBanner) => {
	const applicationDocument = ApplicationDocumentSelector<TApplicationDocument|null>({...props, type: "find"});

    const image = reject([
        props.imagePath ? `${CoreDefault.cdn}/${props.imagePath.replace("\\", "/")}` : null,
        applicationDocument?.filePath ? `${CoreDefault.cdn}/${applicationDocument.filePath.replace("\\", "/")}` : null
    ], isEmpty)?.[0];

    const loaded = useProgressiveImage({ src:image ? `${image}` : null });

	return (
		<div
			className="page-title-area"
			style={loaded?{backgroundImage: `url('${loaded}')`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover"}:undefined}
		>
			<div className="d-table">
				<div className="d-table-cell">
					<div className="container">
						<h2>{props.title}</h2>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PageBanner;
